<template>
  <div
    class="information-requests-page-header d-flex align-center justify-space-between"
    data-testid="information-requests-page-header"
  >
    <div class="information-requests-page-header__title-group d-flex flex-column">
      <div class="d-flex align-center">
        <h3
          class="information-requests-page-header__title ma-0"
          data-testid="information-requests-page-header__title"
        >
          Information Requests
        </h3>
        <v-tooltip bottom content-class="tooltip-bottom">
          <template v-slot:activator="{ on, attrs }">
            <base-button
              v-bind="attrs"
              v-on="on"
              icon="mdi-refresh"
              :icon-style="true"
              class="shadow-off"
              @click="$emit('refresh')"
              data-testid="information-requests-page-header__refresh-btn"
            />
          </template>
          <span>Refresh</span>
        </v-tooltip>
      </div>
      <p
        class="information-requests-page-header__description mb-0"
        data-testid="information-requests-page-header__subtitle"
      >
        Create, assign, and collect supporting documents from information owners for this close cycle
      </p>
    </div>

    <div class="information-requests-page-header__actions d-flex align-center">
      <v-btn
        v-if="showRequestActions && canEdit"
        class="secondaryBtn information-requests-page-header__import-btn"
        :loading="importLoading"
        data-testid="information-requests-page-header__import-btn"
        @click="$emit('import')"
      >
        <img
          src="/img/icons/fbc-icons/ImportTask.svg"
          alt=""
          class="information-requests-page-header__import-icon"
        />
        <span>Import Requests</span>
      </v-btn>
      <v-btn
        v-if="showRequestActions && canAddRequest"
        color="primary"
        class="white--text"
        data-testid="information-requests-page-header__new-request-btn"
        @click="$emit('new-request')"
      >
        <v-icon class="mr-1">mdi-plus</v-icon>
        <span>New Request</span>
      </v-btn>

      <v-menu
        offset-y
        transition="slide-y-transition"
        :close-on-content-click="true"
        content-class="information-requests-page-header__more-menu-panel"
        data-testid="information-requests-page-header__more-menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            class="shadow-off"
            aria-label="More actions"
            data-testid="information-requests-page-header__more-menu-btn"
          >
            <img
              src="/img/icons/threedot.svg"
              alt="More actions"
              class="information-requests-page-header__more-menu-img rotate-90"
            />
          </v-btn>
        </template>
        <div class="information-requests-page-header__more-menu" data-testid="information-requests-page-header__more-menu-list">
          <div class="information-requests-page-header__more-menu-body">
            <button
              v-if="hasRequests"
              type="button"
              class="information-requests-page-header__more-menu-item"
              data-testid="information-requests-page-header__export-btn"
              @click.stop="$emit('download-all')"
            >
              <span class="information-requests-page-header__more-menu-item-content">
                <img
                  src="/img/icons/fbc-icons/ExportIcon.svg"
                  alt=""
                  class="information-requests-page-header__more-menu-img"
                />
                <span class="information-requests-page-header__more-menu-label">Export</span>
              </span>
            </button>
            <button
              type="button"
              class="information-requests-page-header__more-menu-item"
              data-testid="information-requests-page-header__activity-log-menu-btn"
              @click.stop="openActivityLog"
            >
              <span class="information-requests-page-header__more-menu-item-content">
                <img
                  src="/img/icons/activity-log.svg"
                  alt=""
                  class="information-requests-page-header__more-menu-img"
                />
                <span class="information-requests-page-header__more-menu-label">Activity Log</span>
              </span>
            </button>
          </div>
        </div>
      </v-menu>

      <ActivityLog
        hide-trigger
        ref="activityLog"
        :resource-id="activityResourceId"
        row-description="Information Requests"
        :type="ACTIVITY_LOG_TYPES.TASKLIST_IM"
        :config="INFORMATION_REQUESTS_ACTIVITY_LOG_CONFIG"
        data-testid="information-requests-page-header__activity-log"
      />
    </div>
  </div>
</template>

<script>
import './InformationRequestsPageHeader.scss';
import { ACTIVITY_LOG_TYPES, INFORMATION_REQUESTS_ACTIVITY_LOG_CONFIG } from '../../../../../utils/constants';
import { ActivityLog } from '../../../../../components';

export default {
  name: 'InformationRequestsPageHeader',
  components: {
    ActivityLog,
  },
  props: {
    activityResourceId: {
      type: String,
      default: '',
    },
    importLoading: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    hasRequests: {
      type: Boolean,
      default: false,
    },
    canAddRequest: {
      type: Boolean,
      default: false,
    },
    showRequestActions: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ACTIVITY_LOG_TYPES() {
      return ACTIVITY_LOG_TYPES;
    },
    INFORMATION_REQUESTS_ACTIVITY_LOG_CONFIG() {
      return INFORMATION_REQUESTS_ACTIVITY_LOG_CONFIG;
    },
  },
  methods: {
    openActivityLog() {
      const activityLog = this.$refs.activityLog;
      if (activityLog && typeof activityLog.openDialog === 'function') {
        activityLog.openDialog();
        return;
      }
      this.$nextTick(() => {
        this.$refs.activityLog?.openDialog();
      });
    },
  },
};
</script>
